"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePreloader = void 0;

var _react = require("react");

var _preloader = require("./preloader");

/**
 * usePreloader React hook, to preload assets defined on an element, attaching using ref
 * @param {object} ref object, its `current` prop is an element which has the css variables preload expected to get
 * @example
 * ```js (inside a function component, after importing useRef & this hook)
 *  const story = useRef(null);
 *  usePreloader(story);
 *
 *  return <div className='story' ref={story} />
 * ```
 */
const usePreloader = ref => {
  (0, _react.useEffect)(() => {
    if (ref.current) {
      (0, _preloader.preloadFromCSSVars)(ref.current);
    }
  }, [ref.current === null]);
};

exports.usePreloader = usePreloader;